import React from 'react';
import ReactDOM from 'react-dom/client';
import { appConfig } from './app-config.js';
import { ParticipantGate } from './harness/ParticipantGate.jsx';
import { CONTRACT_VERSION } from './inference/types.js';
import { createTelemetry } from './harness/telemetry.js';
import { resolveClientMode } from './inference/runtime.js';
export function buildTelemetryConfig(search, config = appConfig) {
  return {
    endpoint: config.telemetryEndpoint ?? '/api/telemetry',
    authToken: config.telemetryToken ?? null,
    client: resolveClientMode(search, config),
    contractVersion: CONTRACT_VERSION,
    // Without this, a batch that exhausts its retries (see telemetry.js
    // sendEnvelope) fails completely silently, including study_complete,
    // the end-of-session marker a research instrument cannot afford to lose
    // without a trace.
    onError: (error) => {
      console.error('[telemetry] delivery failed', error);
    },
  };
}

export function enrichTelemetryFromHealth(telemetry, inferenceClient, fetchImpl = fetch) {
  if (inferenceClient !== 'http') return Promise.resolve();
  return fetchImpl('/api/infer/health')
    .then((res) => (res.ok ? res.json() : null))
    .then((health) => {
      const context = {};
      if (health?.providers) context.provider = health.providers;
      if (health?.models) context.model = health.models;
      if (Object.keys(context).length > 0) telemetry.setContext(context);
    })
    .catch(() => {
      // Provider enrichment is best-effort. Rows remain useful without it.
    });
}

export function mountPrivacyMeter({
  root = document.getElementById('root'),
  search = window.location.search,
  config = appConfig,
} = {}) {
  const telemetryConfig = buildTelemetryConfig(search, config);
  const telemetry = createTelemetry(telemetryConfig);
  enrichTelemetryFromHealth(telemetry, telemetryConfig.client);

  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <ParticipantGate telemetry={telemetry} appConfig={config} />
    </React.StrictMode>
  );
  return telemetry;
}

if (typeof document !== 'undefined' && document.getElementById('root')) {
  mountPrivacyMeter();
}
